<template>
  <Transition name="header-menu-slide">
    <div
      class="header-desktop"
      :class="{ 'header-desktop_bg-hidden': isBgHidden }"
      v-show="!isHeaderHidden"
    >
      <div class="header-desktop__content container" data-aos="fade-down">
        <NuxtLink href="/">
          <img
            class="header-desktop__logo"
            alt="Logo"
            :src="logoUri"
          />
        </NuxtLink>
        <div class="header-desktop__nav-items">
          <NuxtLink
            class="header-desktop__nav-item"
            :class="{
              'header-desktop__nav-item_active': route.path.includes(item.url),
            }"
            active-class="header-desktop__nav-item_active"
            v-for="item in navItems.filter((item) => !item.hidden)"
            :key="item.url"
            :href="item.url"
          >
            {{ item.title }}
          </NuxtLink>
          <SocialIcons class="header-desktop__socials" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import defaultLogoUri from "@/assets/images/logo.webp";
  import { useWebsiteContent } from "~/layers/website/composables/useWebsiteContent";

  export interface HeaderDesktopProps {
    navItems: {
      title: string;
      url: string;
      hidden?: boolean;
    }[];
    isHeaderHidden: boolean;
    isBgHidden: boolean;
  }

  const props = defineProps<HeaderDesktopProps>();
  const route = useRoute();

  const {getGeneralSettings } = useWebsiteContent();
  const { data: generalSettings, suspense: suspenseGeneralSettings } = getGeneralSettings();

  const logoUri = computed<string>(() => {
    return generalSettings.value?.logoLight || defaultLogoUri;
  });

  await suspenseGeneralSettings();
</script>

<style scoped lang="scss">
  .header-desktop {
    display: flex;
    justify-content: center;
    align-items: center;

    //background: #182656;
    //background: rgba(10, 17, 44, 0.75);
    background: #0a1129aa;
    backdrop-filter: blur(4px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);

    padding: 32px 0;

    transition: all 200ms ease-out;

    &_bg-hidden {
      background-color: transparent;
      box-shadow: none;
      backdrop-filter: none;
    }

    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__logo {
      height: 48px;

      transition: all 200ms ease-out;

      &:hover {
        scale: 1.05;
      }
    }

    &__nav-items {
      display: flex;
      align-items: center;
      gap: 40px;
    }

    &__nav-item {
      color: #ffffff;
      font-size: 22px;
      font-weight: 800;
      white-space: nowrap;
      text-transform: uppercase;
      text-decoration: none;

      transition: all 200ms ease-out;

      &:hover,
      &_active {
        color: #e43233;
      }
    }
  }
</style>
